import { InvitationService } from './invitation.service';
import { RegisterCompanyService } from '@aid/auth/services/register-company.service';

export const services = [InvitationService, RegisterCompanyService];

export * from './auth.service';
export * from './invitation.service';
export * from './jwt.service';
export * from './register-company.service';
